import React from "react";
const axios = require('axios');

import {CART_UPDATED} from "../util/events";
import dispatchEvent from "../util/dispatchEvent";

import CloseIcon from "../icons/CloseIcon";
import IncreaseIcon from "../icons/IncreaseIcon";
import DecreaseIcon from "../icons/DecreaseIcon";


class CartLineItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            quantity: this.props.item.quantity,
            rate: this.props.item.rate ? this.props.item.rate : ''
        }

        this.cancelToken = null;

        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.syncOrderItem = this.syncOrderItem.bind(this);
        this.updateOrderItemRate = this.updateOrderItemRate.bind(this);
    }

    increaseQuantity(e)
    {
        e.preventDefault();
        this.setState({
            quantity: this.state.quantity + 1
        }, () => {
            this.syncOrderItem()
        });
    }

    decreaseQuantity(e)
    {
        e.preventDefault();
        let qty = this.state.quantity - 1;
        if (qty < 1) {
            qty = 1;
        }
        this.setState({
            quantity: qty
        }, () => {
            this.syncOrderItem()
        });

    }

    updateQuantity(qty)
    {
        if (qty < 0) {
            qty = 1;
        }
        this.setState({
            quantity: qty
        }, () => {
            this.syncOrderItem()
        });
    }

    updateOrderItemRate(rate)
    {
        if (this.cancelToken) {
            this.cancelToken();
        }

        axios({
            method: 'post',
            url: 'cart-api/update-rate',
            data: {
                o_i: this.props.item.id,
                rate: this.state.rate
            },
            cancelToken: axios.CancelToken((c) => {
                this.cancelToken = c;
            })
        }).then((response) => {
            dispatchEvent(CART_UPDATED, response.data);
        });
    }

    syncOrderRate()
    {
        if (this.cancelToken) {
            this.cancelToken();
        }
        // this.cancelToken = axios.CancelToken.source();
        axios({
            method: 'post',
            url: 'cart-api/update',
            data: {
                o_i: this.props.item.id,
                qty: this.state.quantity
            },
            cancelToken: axios.CancelToken((c) => {
                this.cancelToken = c;
            })
        }).then((response) => {
            dispatchEvent(CART_UPDATED, response.data);
        });
    }

    syncOrderItem()
    {
        if (this.cancelToken) {
            this.cancelToken();
        }
        // this.cancelToken = axios.CancelToken.source();
        axios({
            method: 'post',
            url: 'cart-api/update',
            data: {
                o_i: this.props.item.id,
                qty: this.state.quantity
            },
            cancelToken: axios.CancelToken((c) => {
                this.cancelToken = c;
            })
        }).then((response) => {
            dispatchEvent(CART_UPDATED, response.data);
        });
    }

    removeItem(e)
    {
        e.preventDefault();
        axios.post('cart-api/remove', {
            o_i: this.props.item.id
        }).then((response) => {
            dispatchEvent(CART_UPDATED, response.data);
        });
        return false;
    }

    render()
    {
        const item = this.props.item;

        let qty = null;

        if (this.props.cartCheckout) {
            qty = <div className="cart-sidebar__line__qty">
                <label>Quantity</label>
                <p>{this.state.quantity}</p>
            </div>;
        } else {
            qty = <div className="cart-sidebar__line__qty">
                <label>Quantity</label>
                <div className="cart-sidebar__line__qty-holder">
                    <input type="text"
                           value={this.state.quantity}
                           onChange={(e) => {
                               this.updateQuantity(e.target.value);
                           }}/>
                    <ul>
                        <li><a onClick={this.increaseQuantity}> <IncreaseIcon/> </a></li>
                        <li><a onClick={this.decreaseQuantity}> <DecreaseIcon/> </a></li>
                    </ul>
                </div>
            </div>;
        }

        let priceDom = <span>{item.price}</span>;

        if (this.props.isEdit && !this.props.cartCheckout) {
            priceDom = <span>$<input
                value={this.state.rate ? this.state.rate : ''}
                className={'cart-sidebar__rate-input'}
                onChange={(e) => {
                    const sanitisedRate = e.target.value.replace(/[^0-9.]/g, '');
                    this.setState({
                        rate: sanitisedRate
                    });
                }}
                onBlur={(e) => {
                    this.updateOrderItemRate(e.target.value)
                }}
            /></span>
        }

        return <div className="cart-sidebar__line">
            <div className="cart-sidebar__line__inner">
                <div className="cart-sidebar__line__main">
                    <div className="cart-sidebar__line__image">
                        <a href={item.product_link}>
                            {!!item.image && <img src={item.image} alt={item.product_title}/>}
                        </a>
                    </div>
                    <div className="cart-sidebar__line__desc">
                        <div>
                            <h3><a href={item.product_link}>{item.product_title}</a></h3>
                            <p className="cart-sidebar__line__price">
                                <span>{priceDom}</span>
                                <label>GST Included</label>
                            </p>
                        </div>
                        {!this.props.cartCheckout && <p className="cart-sidebar__line__remove-btn">
                            <a href={'#'} onClick={this.removeItem}
                               className="btn btn--white btn--white--solid">Remove</a>
                        </p>}
                    </div>

                </div>
                {qty}
            </div>
        </div>
    }

}


export default CartLineItem;
